module.exports = __webpack_public_path__ + "img/logo-top.4a08ecd2.png";